import React, { useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Form, Input, Select, Space, Spin } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import { Add, Delete, OpenInFull, Refresh, SwipeUp } from '@mui/icons-material';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import { FormProvider, useForm } from 'react-hook-form';
import Data from '../../../../Data/Data.json'
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchInput from '../../../SearchInput';
import SearchModal from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import ShowFile from '../../../ShowFile';
import Relation from '../../../../Models/Relation';
import RELATION from '../../../../Models/Relation';
import Billetage from '../../../Billetage';
import InputForm from '../../../InputT';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Utilisateur from '../../../../Models/Utilisateur';
import { useNavigate } from 'react-router-dom';
import Caisse from '../../../../Models/Caisse';

interface SelectData {
  value: string,
  label: string,
}

function Tab3(props: { form?: any, caisse?: Caisse }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [numcli, setNumcli] = useState("")
  const [numcpt, setNumcpt] = useState("")
  const [competClients, SetCompetClients] = React.useState<SelectData[]>([]);
  const [loading, setLoading] = useState(false)
  const [loadCompte, setLoadCompte] = useState(false)
  const [numcptEpargne, setNumcptEpargne] = useState("")
  const [accountSelected, setAccountSelected] = useState(false)
  const [typeOpe, setTypeOpe] = useState("")
  const [branchSelected, setBranchSelected] = useState(false)
  const [signataire, setSignataire] = useState<any[]>([])
  const [procuration, setProcuration] = useState<any[]>([])
  const navigate = useNavigate()

  // USER TOKEN
  const authHeader = useAuthHeader()



  // function getToatal() {
  //   props.form.setFieldValue('TotalBilletage',
  //     formatNumber(
  //       parseInt((props.form.getFieldValue("NOMB01") ? props.form.getFieldValue("NOMB01") : 0)) * 10000 +
  //       parseInt((props.form.getFieldValue("NOMB02") ? props.form.getFieldValue("NOMB02") : 0)) * 5000 +
  //       parseInt((props.form.getFieldValue("NOMB03") ? props.form.getFieldValue("NOMB03") : 0)) * 2000 +
  //       parseInt((props.form.getFieldValue("NOMB04") ? props.form.getFieldValue("NOMB04") : 0)) * 1000 +
  //       parseInt((props.form.getFieldValue("NOMB05") ? props.form.getFieldValue("NOMB05") : 0)) * 500 +
  //       parseInt((props.form.getFieldValue("NOMB06") ? props.form.getFieldValue("NOMB06") : 0)) * 500 +
  //       parseInt((props.form.getFieldValue("NOMB07") ? props.form.getFieldValue("NOMB07") : 0)) * 100 +
  //       parseInt((props.form.getFieldValue("NOMB08") ? props.form.getFieldValue("NOMB08") : 0)) * 50 +
  //       parseInt((props.form.getFieldValue("NOMB09") ? props.form.getFieldValue("NOMB09") : 0)) * 25 +
  //       parseInt((props.form.getFieldValue("NOMB10") ? props.form.getFieldValue("NOMB10") : 0)) * 10 +
  //       parseInt((props.form.getFieldValue("NOMB11") ? props.form.getFieldValue("NOMB11") : 0)) * 5 +
  //       parseInt((props.form.getFieldValue("NOMB12") ? props.form.getFieldValue("NOMB12") : 0)) * 2 +
  //       parseInt((props.form.getFieldValue("NOMB13") ? props.form.getFieldValue("NOMB13") : 0)) * 1)
  //   )
  // }
  // function getToatal2() {
  //   props.form.setFieldValue('TotalBilletage_1',
  //     formatNumber(
  //       parseInt((props.form.getFieldValue("NOMB01_1") ? props.form.getFieldValue("NOMB01_1") : 0)) * 10000 +
  //       parseInt((props.form.getFieldValue("NOMB02_1") ? props.form.getFieldValue("NOMB02_1") : 0)) * 5000 +
  //       parseInt((props.form.getFieldValue("NOMB03_1") ? props.form.getFieldValue("NOMB03_1") : 0)) * 2000 +
  //       parseInt((props.form.getFieldValue("NOMB04_1") ? props.form.getFieldValue("NOMB04_1") : 0)) * 1000 +
  //       parseInt((props.form.getFieldValue("NOMB05_1") ? props.form.getFieldValue("NOMB05_1") : 0)) * 500 +
  //       parseInt((props.form.getFieldValue("NOMB06_1") ? props.form.getFieldValue("NOMB06_1") : 0)) * 500 +
  //       parseInt((props.form.getFieldValue("NOMB07_1") ? props.form.getFieldValue("NOMB07_1") : 0)) * 100 +
  //       parseInt((props.form.getFieldValue("NOMB08_1") ? props.form.getFieldValue("NOMB08_1") : 0)) * 50 +
  //       parseInt((props.form.getFieldValue("NOMB09_1") ? props.form.getFieldValue("NOMB09_1") : 0)) * 25 +
  //       parseInt((props.form.getFieldValue("NOMB10_1") ? props.form.getFieldValue("NOMB10_1") : 0)) * 10 +
  //       parseInt((props.form.getFieldValue("NOMB11_1") ? props.form.getFieldValue("NOMB11_1") : 0)) * 5 +
  //       parseInt((props.form.getFieldValue("NOMB12_1") ? props.form.getFieldValue("NOMB12_1") : 0)) * 2 +
  //       parseInt((props.form.getFieldValue("NOMB13_1") ? props.form.getFieldValue("NOMB13_1") : 0)) * 1)
  //   )
  // }

  return (

    <div className='tabItem' >
      <Box >


        <Box style={{ width: "105%" }}>
          <Box fontStyle="inherit"  className='bordure1'>
            <legend>Détail billetage sortie de la caisse</legend>
            <Billetage form={props.form} withTatal />
            {/* <Box display={"flex"} fontStyle="inherit">
              <Box fontStyle="inherit" >
                <Box fontStyle={"inherit"} marginTop={-2} className='bordure1'>
                  <InputForm onChange={getToatal} width={11} money label='Billet de 10 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB01' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal} width={11} money label='Billet de 5 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB02' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal} width={11} money label='Billet de 2 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB03' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal} width={11} money label='Billet de 1 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB04' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal} width={11} money label='Billet de 500' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB05' type='number' error='mobile' defaultValue={0} />
                </Box>
              </Box><hr />
              <Box fontStyle={"inherit"} >
                <Box display={"flex"} fontStyle={"inherit"} marginTop={-2} className='bordure1'>
                  <Box fontStyle="inherit" >
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 500' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB06' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 100' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB07' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 50' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB08' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 25' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB09' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 10' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB10' type='number' error='mobile' defaultValue={0} />
                  </Box><hr />
                  <Box fontStyle="inherit" >
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 5' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB11' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 2' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB12' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal} width={11} money label='Pièce de 1' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB13' type='number' error='mobile' defaultValue={0} />
                  </Box>
                </Box>
              </Box>
            </Box>
            <InputForm notRequired width={11} disabled label='Total Sorties' icon={<SwipeUp color='disabled' fontSize='small' />} name='TotalBilletage' type='text' error='mobile' defaultValue={0} /> */}
          </Box>


          <Box fontStyle="inherit"  className='bordure1'>
            <legend>Détail billetage entré en caisse</legend>

            <Billetage form={props.form} second={true} withTatal/>
            {/* <Box display={"flex"} fontStyle="inherit">
              <Box fontStyle="inherit" >
                <Box fontStyle={"inherit"} marginTop={-2} className='bordure1'>
                  <InputForm onChange={getToatal2} width={11} label='Billet de 10 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB01_1' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal2} width={11} label='Billet de 5 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB02_1' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal2} width={11} label='Billet de 2 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB03_1' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal2} width={11} label='Billet de 1 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB04_1' type='number' error='mobile' defaultValue={0} />
                  <InputForm onChange={getToatal2} width={11} label='Billet de 500' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB05_1' type='number' error='mobile' defaultValue={0} />
                </Box>
              </Box><hr />
              <Box fontStyle={"inherit"}>
                <Box display={"flex"} fontStyle={"inherit"} marginTop={-2} className='bordure1'>
                  <Box fontStyle="inherit" >
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 500' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB06_1' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 100' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB07_1' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 50' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB08_1' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 25' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB09_1' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 10' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB10_1' type='number' error='mobile' defaultValue={0} />
                  </Box><hr />
                  <Box fontStyle="inherit" >
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 5' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB11_1' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 2' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB12_1' type='number' error='mobile' defaultValue={0} />
                    <InputForm onChange={getToatal2} width={11} label='Pièce de 1' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB13_1' type='number' error='mobile' defaultValue={0} />
                  </Box>
                </Box>
              </Box>
            </Box>
            <InputForm notRequired width={11} disabled label='Total Entrées' icon={<SwipeUp color='disabled' fontSize='small' />} name='TotalBilletage_1' type='text' error='mobile' defaultValue={0} /> */}
          </Box>
        </Box>

        <Box display={'flex'} className='bordure1' style={{ width: "104%" }}>
          <InputForm disabled label='Caisse' type={'text'} value={props.caisse?.NODECE + ' - ' + props.caisse?.LECEON} />
          <hr />
          <InputForm disabled label='Utilisateur de la Caisse' type={'text'} value={props.caisse?.CAIUTI} />
          <hr />
          <InputForm disabled label='Compte Caisse' type={'text'} value={props.caisse?.NUMCPT} />
        </Box>
      </Box>
    </div>
  );
}

export default Tab3;